import type { ReactNode } from 'react';

/**
 * 목록의 대기·실패·빈 상태.
 *
 * <p><b>실패 사유를 화면에 쓰지 않는다.</b> 「불러오는 중입니다」 까지가 사용자의 몫이고,
 * 무엇이 왜 실패했는지는 서버 로그와 관리자 화면에서 본다 — 외부 사용자에게 내부 오류 코드를
 * 보여 주면 그것 자체가 시스템의 모양을 알려 주는 통로가 된다.
 */
export function QueryState({
  pending,
  error,
  empty,
  emptyText,
  children,
}: {
  pending: boolean;
  error: boolean;
  empty: boolean;
  emptyText: string;
  children: ReactNode;
}) {
  if (pending) {
    return <p className="py-6 text-center text-ui-sm" style={{ color: 'var(--text-muted)' }}>불러오는 중입니다…</p>;
  }
  if (error) {
    return <p className="py-6 text-center text-ui-sm" style={{ color: 'var(--text-muted)' }}>지금은 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.</p>;
  }
  if (empty) {
    return <p className="py-6 text-center text-ui-sm" style={{ color: 'var(--text-muted)' }}>{emptyText}</p>;
  }
  return <>{children}</>;
}
